import(/* webpackMode: "eager" */ "/vercel/path0/src/app/komis-samochodowy/@content/[[...variables]]/loading.tsx")